import { TabPanel } from '@mui/lab';
import {
  NumberFieldTemplate,
  SelectFieldTemplate,
  StringFieldTemplate,
} from '../forms';
import { DateFieldTemplate } from '../forms/DateFieldTemplate';
import { FieldTemplate, FieldType } from 'api/models/FieldTemplate';
import { FormikProps } from 'formik';
import { CalculatedFieldTemplate } from '../forms/CalculatedFieldTemplate';
import { AddFieldValues } from '../AddFieldTemplateDialog';
import { projectState } from 'state';
import { useRecoilValue } from 'recoil';

interface FieldConfigTagProps {
  field: FieldTemplate;
  formik: FormikProps<AddFieldValues>;
  disabled: boolean;
}

export default function FieldConfigTab({
  field,
  formik,
  disabled,
}: FieldConfigTagProps) {
  const { selectedProject } = useRecoilValue(projectState);
  const isRepeatingFieldsEnabled =
    selectedProject?.configuration?.repeatingFieldsEnabled ?? false;
  return (
    <TabPanel value="1" sx={{ pl: 0, pr: 0 }}>
      {field.fieldType === FieldType.Number && (
        <NumberFieldTemplate
          isRepeatingFieldsEnabled={isRepeatingFieldsEnabled}
          formik={formik}
          disabled={formik.isSubmitting || disabled}
        />
      )}

      {field.fieldType === FieldType.Text && (
        <StringFieldTemplate
          formik={formik}
          isRepeatingFieldsEnabled={isRepeatingFieldsEnabled}
          disabled={formik.isSubmitting || disabled}
        />
      )}

      {field.fieldType === FieldType.Select && (
        <SelectFieldTemplate
          formik={formik}
          isRepeatingFieldsEnabled={isRepeatingFieldsEnabled}
          field={field}
          disabled={formik.isSubmitting || disabled}
        />
      )}

      {field.fieldType === FieldType.Date && (
        <DateFieldTemplate
          formik={formik}
          isRepeatingFieldsEnabled={isRepeatingFieldsEnabled}
          disabled={formik.isSubmitting || disabled}
        />
      )}

      {field.fieldType === FieldType.Calculated && (
        <CalculatedFieldTemplate
          formik={formik}
          isRepeatingFieldsEnabled={isRepeatingFieldsEnabled}
          disabled={formik.isSubmitting || disabled}
        />
      )}
    </TabPanel>
  );
}
